export const appConfig = {
  tablePageSizes: [10, 50, 100],

  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/,
};
